<div class="col-md-12" id="cfet-no-verification-required-container">
  <picture>
    <source media="(min-width: 767px)" srcset="assets/images/NoVerificationRequired.png">
    <img id="verification-pending-icon" src="assets/images/NoVerificationRequired.png" alt="Review icon">
  </picture>

  <div class="row" id="pending-verification-content">
    <div class="col-md-12">
      <h2 id="pending-verification-heading">
        <strong>{{cfetLabels.cfet_verification_information.noverification_required_heading}}</strong></h2>
      <ol id="pending-verification-desc">
        <li class="desc1">{{cfetLabels.cfet_verification_information.noverification_required_desc1}}</li>
        <li class="desc1">{{cfetLabels.cfet_verification_information.noverification_required_desc2}}</li>
        <li class="desc1">{{cfetLabels.cfet_verification_information.noverification_required_desc3}}</li>
      </ol>
    </div>
  </div>

  <div class="row col-md-12" id="instant-verification-footer-column">
    <button type="button" id="btn-continue" (click)="continueToProfile($event)" (keyup)="continueToProfile($event)"
      class="btn btn-alt btn-medium" tabindex="0">{{cfetButtonLabels.button_labels.continueToProfile}}</button>

    <a data-dismiss="modal" (click)="cancelCreation($event)" (keyup)="cancelCreation($event)" tabindex="0"
      id="cancel_link" class="cancel_link">
      {{cfetButtonLabels.button_labels.cancel}}</a>
  </div>

</div>